// Date-only arithmetic deliberately stays independent of browser timezone and DST.
export const restaurantLocalDate = (timezone, now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = (type) => parts.find((p) => p.type === type).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
};

const dateOnly = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
};

export const validateStaffTipRange = (start, end) => {
  const from = dateOnly(start);
  const to = dateOnly(end);
  if (!from || !to) return 'Choose valid start and end dates (YYYY-MM-DD).';
  const days = (to - from) / 86400000 + 1;
  if (days < 1) return 'End date must be on or after start date.';
  if (days > 366) return 'Choose a range of 366 days or fewer, including both dates.';
  return '';
};

export const staffTipWeekRange = (timezone, now = new Date(), weekOffset = 0) => {
  const date = dateOnly(restaurantLocalDate(timezone, now));
  date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7 + weekOffset * 7);
  const start_date = date.toISOString().slice(0, 10);
  date.setUTCDate(date.getUTCDate() + 6);
  return { start_date, end_date: date.toISOString().slice(0, 10) };
};

// A null intersection has no reportable dates; never request an inverted range.
export const staffTipEffectiveRange = (start, end, today) => (
  start > today ? null : { start_date: start, end_date: end > today ? today : end }
);

// Only an authoritative, complete decimal zero can hide a day. Counts do not
// determine tip activity, and unknown amounts must never be treated as zero.
export const isCompleteZeroTip = (summary) => Boolean(
  summary && !summary.incomplete
  && !(summary.unknown_amount_rows > 0) && !(summary.unknown_amount_order_count > 0)
  && typeof summary.amount === 'string' && /^[+-]?0+\.00$/.test(summary.amount)
);

// Format exact API decimals as strings: never round or sum financial data.
export const formatTipUSD = (amount) => {
  if (typeof amount !== 'string' || !/^-?\d+\.\d{2}$/.test(amount)) return 'Incomplete';
  const negative = amount.startsWith('-');
  const [whole, cents] = amount.replace(/^-/, '').split('.');
  return `${negative ? '-' : ''}$${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${cents}`;
};
